__turbopack_context__.v({
  "eyebrow": "HostingReliabilitySection-module__nK4Etq__eyebrow",
  "grid": "HostingReliabilitySection-module__nK4Etq__grid",
  "header": "HostingReliabilitySection-module__nK4Etq__header",
  "metricBadge": "HostingReliabilitySection-module__nK4Etq__metricBadge",
  "metricLabel": "HostingReliabilitySection-module__nK4Etq__metricLabel",
  "metricValue": "HostingReliabilitySection-module__nK4Etq__metricValue",
  "metrics": "HostingReliabilitySection-module__nK4Etq__metrics",
  "section": "HostingReliabilitySection-module__nK4Etq__section",
  "sub": "HostingReliabilitySection-module__nK4Etq__sub",
  "tile": "HostingReliabilitySection-module__nK4Etq__tile",
  "tileIcon": "HostingReliabilitySection-module__nK4Etq__tileIcon",
  "tileText": "HostingReliabilitySection-module__nK4Etq__tileText",
  "tileTitle": "HostingReliabilitySection-module__nK4Etq__tileTitle",
  "title": "HostingReliabilitySection-module__nK4Etq__title",
});
